module.exports = __webpack_public_path__ + "media/images/emblems/Buchs-blazon-f1a4b2533c6963f5e827754584726af5.svg";